import { call, put, takeLatest } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRouter from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import {
  FETCH_JOB_INPUT_ITEM_TABLE_DATA,
  FETCH_JOB_INPUT_ITEM_TABLE_DATA_FAILURE,
  FETCH_JOB_INPUT_ITEM_TABLE_DATA_SUCCESS,
} from './reducer'

export function* fetchJobInputItemsTable({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${
        ApiRouter.JOB_WORKFLOW_INPUT_ITEMS_TABLE
      }${UrlHelper.getPsfsQuery(payload)}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_JOB_INPUT_ITEM_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_JOB_INPUT_ITEM_TABLE_DATA_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB INPUT GROUP DATA ERROR', error)
  }
}

function* jobInputItemsAdminSaga() {
  yield takeLatest(FETCH_JOB_INPUT_ITEM_TABLE_DATA, fetchJobInputItemsTable)
}

export default jobInputItemsAdminSaga
